// Behind-the-scenes photography for the About page.
// Extend by appending entries — the masonry gallery adapts automatically.
export const BTS = [
  {
    src: "/bts/bts-01-keith-editing.jpg",
    alt: "Yellow's Keith Lupton reviewing product photography on a dual-monitor edit suite",
    w: 1400,
    h: 1054,
  },
  {
    src: "/bts/bts-02-hoya-interview.jpg",
    alt: "Interviewing a subject on the Hoya MiYOSMART campaign set with softboxes and boom microphone",
    w: 1400,
    h: 1859,
  },
  {
    src: "/bts/bts-03-edit-suite.jpg",
    alt: "Editing a client film on Adobe Premiere in Yellow's Liverpool edit suite",
    w: 1400,
    h: 933,
  },
  {
    src: "/bts/bts-04-theatre-interview.jpg",
    alt: "Filming a wheelchair-user interview on a theatre stage with cinema camera and boom mic",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-05-marie-curie.jpg",
    alt: "Behind the camera filming Marie Curie representatives at an industry conference stand",
    w: 1400,
    h: 933,
  },
  {
    src: "/bts/bts-06-carragher-interview.jpg",
    alt: "Filming Jamie Carragher for a Community Foundation for Merseyside charity campaign",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-07-fixfirm-interview.jpg",
    alt: "Interviewing a FixFirm spokesperson with a Blackmagic cinema camera and boom mic",
    w: 1400,
    h: 933,
  },
  {
    src: "/bts/bts-08-salon-shoot.jpg",
    alt: "Filming a beauty salon commercial with dual Blackmagic cinema cameras and monitors",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-09-camera-op-location.jpg",
    alt: "Yellow camera operators framing a shot on location with a rig-mounted Orion 40mm cine lens",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-10-kitchen-interview.jpg",
    alt: "Filming a friendly kitchen-set interview with a Blackmagic camera and V-mount battery",
    w: 1400,
    h: 933,
  },
  {
    src: "/bts/bts-11-nhs-nurse-interview.jpg",
    alt: "Filming an NHS nurse interview seen through a Blackmagic monitor with softbox lighting",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-12-caterham-track.jpg",
    alt: "On location at a Caterham Experience track day filming a driver on the airfield circuit",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-13-product-shoot-home.jpg",
    alt: "Yellow crew filming a homewares product demonstration in a bright kitchen setting",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-14-lyra-light-setup.jpg",
    alt: "Setting up an iKan LYRA softbox key light for a two-camera interview shoot on location",
    w: 1024,
    h: 683,
  },
  {
    src: "/bts/bts-15-liverpool-hope-uni.jpg",
    alt: "Yellow crew filming a walkabout piece at the Liverpool Hope University campus entrance",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-16-hospital-nurse-interview.jpg",
    alt: "Filming a hospital nurse interview with a Blackmagic cinema camera, boom mic and softbox",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-18-restaurant-interview.jpg",
    alt: "Filming a business owner interview in a warmly lit restaurant with two-camera set-up",
    w: 1400,
    h: 1050,
  },
  {
    src: "/bts/bts-20-wed4less-shoot.jpg",
    alt: "On the Wed4Less bridal fashion shoot with models in silver dresses on a white cyclorama",
    w: 1400,
    h: 1050,
  },
];
